// extracted by mini-css-extract-plugin
export default {"content":"content--mkqMH","center":"center--b9F23","left":"left--GuHhO","right":"right--W8yjV"};